import { isMacOS } from '@tiptap/react';

export const useModKey = () => (isMacOS() ? '⌘' : 'Ctrl');
